export const ObtenerUsuarios = () => {
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/usuarios.php?funcion=usuarios',{
            method:'POST',
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const GuardarUsuario = (usuario) => {
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/usuarios.php?funcion=agregarUsuario',{
            method:'POST',
            body:JSON.stringify(usuario)
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}